import Header from './components/Header';
import Hero from './components/Hero';
import Feed from './components/Feed';
import Channels from './components/Channels';
import RankSection from './components/RankSection';
import Reports from './components/Reports';
import About from './components/About';
import Faq from './components/Faq';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';
import Floating from './components/Floating';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Feed />
        <Channels />
        <RankSection />
        <Reports />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <Floating />
    </>
  );
}